export const data_tech_steps = {
  prefix: 'Try it out',
  title: 'Step Up and Try AI Shopping </br> <span>for Yourself </span>',
  description: 'Experience the SoftServe Gen AI Retail Shopping Assistant for yourself. Follow these simple steps at our booth:',
  items: [
    {
      title: 'Find What You Need',
      description: 'Search for an item by simply typing into the chat session.',
    },
    {
      title: 'Chat with the Assistant',
      description: 'Not sure what you’re looking for? Just ask. Try something like, “I’m going skiing and need a vest,” and let the assistant find the perfect options for you.',
    },
    {
      title: 'Step Up to the Kiosk',
      description: 'Take a quick picture using the kiosk camera (just follow the on-screen instructions) or select from one of our existing avatars.',
    },
    {
      title: 'See Yourself Instantly',
      description: 'Your image will appear on the screen, ready for virtual try-ons.',
    },
    {
      title: 'Try It On',
      description: 'See how the item looks on you in real time.',
    },
    {
      title: 'Discover More',
      description: 'The assistant can suggest other items that match your style, needs, or occasion, helping you put together the perfect look.',
    },
  ]
};
